import noop from "lodash/noop";
import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import { useBreakpoint } from "@Hooks/useBreakpoint";
import { HeaderMenuLink } from "@Types/header";
import "./style.scss";

interface Props {
  accountLinks: HeaderMenuLink[];
}

const HeaderAccount: FunctionComponent<Props> = ({ accountLinks }) => {
  const { isMediumScreen } = useBreakpoint();
  const intl = useIntl();

  return (
    <div className="HeaderAccount">
      {accountLinks.map(({ className, label, name, onclick, url }) => {
        const handleClickToSignIn = () => (onclick ? onclick("signIn") : noop);

        const handleClickToSignUp = () => (onclick ? onclick("signUp") : noop);

        return url ? (
          <a className={`HeaderAccount-link ${className ? className : ""}`} href={url} key={label}>
            {intl.formatMessage({ id: `cheerz_Header_${label}` })}
          </a>
        ) : (
          <div className={`HeaderAccount-link ${className ? className : ""}`} key={label}>
            {label === "signOut" && (
              <>
                <span className="HeaderAccount-signOut-hello">
                  {intl.formatMessage({ id: "cheerz_Header_signOut_hello" })}
                  {name ? ` ${name} 👋` : " 👋"}
                </span>
                <span className="HeaderAccount-signOut-log" onClick={onclick ? onclick : noop}>
                  {intl.formatMessage({ id: "cheerz_Header_signOut" })}
                </span>
              </>
            )}
            {label === "login" && (
              <>
                <ButtonSmily onClick={handleClickToSignIn} size="s" type="primary">
                  {intl.formatMessage({ id: "cheerz_Header_login" })}
                </ButtonSmily>
                <div
                  className="HeaderAccount-login-link"
                  onClick={isMediumScreen ? handleClickToSignUp : noop}
                >
                  <span className="HeaderAccount-login-link-hello">
                    {intl.formatMessage({ id: "cheerz_Header_login_hello" })}
                  </span>
                  <span className="HeaderAccount-login-link-log" onClick={handleClickToSignUp}>
                    {intl.formatMessage({ id: "cheerz_Header_signUp" })}
                  </span>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default HeaderAccount;
